export default "__VITE_ASSET__ah0lcYti__"